export enum AuthStatus {
  OK = 'OK',
  EON_USER_NOT_FOUND = 'EON_USER_NOT_FOUND',
  NO_FIRM_ACCESS = 'NO_FIRM_ACCESS',
}
